import type { User } from '@/types/user'
import { isRestrictedPath } from '@/lib/auth/roles'

import type { CommandItem } from './omnibar-items'

function pathnameFromHref(href: string): string {
	if (href.startsWith('http://') || href.startsWith('https://')) {
		try {
			return new URL(href).pathname
		} catch {
			return href
		}
	}
	return href.split('?')[0].split('#')[0]
}

/** Whether the user may open this href — mirrors side nav / AuthorizationGuard rules. */
export function canAccessOmnibarHref(user: User | null | undefined, href: string): boolean {
	if (!user) return false

	if (href.startsWith('http://') || href.startsWith('https://')) {
		return true
	}

	return !isRestrictedPath(user, pathnameFromHref(href))
}

export function filterCommandItemsForUser(
	items: CommandItem[],
	user: User | null | undefined,
): CommandItem[] {
	if (!user) return []
	return items.filter((item) => canAccessOmnibarHref(user, item.href))
}
